const architecturePage = {
  diagramTitle: "דיאגרמת ארכיטקטורה",
  toolStackTitle: "מפת כלים",
  layerUI: "ממשק משתמש",
  layerDB: "מסד נתונים",
  layerSOT: "מקור אמת תפעולי",
  layerKnowledge: "מקור אמת ידע",
  layerAutomation: "אוטומציה",
  layerMessaging: "הודעות",
  colTool: "כלי",
  colLayer: "שכבה",
  colRole: "תפקיד",
  colDoesNot: "לא עושה",
  readOnly: "קריאה בלבד",
  dataFromClaudeMd: "מבוסס על CLAUDE.md",
} as const;
export default architecturePage;
